import React, { useState, useEffect } from "react";
import { FaTrashAlt, FaTimes, FaExclamationTriangle, FaCheckCircle } from "react-icons/fa";

export const DeleteFolderModal = ({
  isOpen,
  onClose,
  onConfirm,
  folderName = "",
  itemType = "Class Folder",
  loading = false,
}) => {
  // Requirement: Default "No" button par tick rahega
  const [selectedOption, setSelectedOption] = useState("no");

  useEffect(() => {
    if (isOpen) {
      setSelectedOption("no"); // Always reset to "no" when modal opens
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (selectedOption === "yes" && !loading) {
      onConfirm();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      onClose();
    }
  };

  return (
    <div
      className="delete-modal-overlay"
      onClick={onClose}
      onKeyDown={handleKeyDown}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="delete-modal-box"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="delete-modal-close-btn"
          onClick={onClose}
          disabled={loading}
          title="Close dialog"
        >
          <FaTimes />
        </button>

        <div className="delete-modal-icon-wrapper">
          <div className="delete-modal-icon-circle">
            <FaExclamationTriangle />
          </div>
        </div>

        <h3 className="delete-modal-title">Delete {itemType}?</h3>
        <p className="delete-modal-subtitle">
          Are you sure you want to delete{" "}
          <strong className="folder-name-highlight">"{folderName}"</strong>?
          <br />
          All student photos and files in this folder will be permanently removed.
        </p>

        {/* Radio options: Default is "NO" (ticked) */}
        <div className="delete-options-group">
          <label
            className={`delete-option-label ${selectedOption === "no" ? "active-no" : ""}`}
            onClick={() => setSelectedOption("no")}
          >
            <input
              type="radio"
              name="deleteOption"
              value="no"
              checked={selectedOption === "no"}
              onChange={() => setSelectedOption("no")}
            />
            <div className="option-text">
              <span className="option-headline">
                No, Keep Folder <span className="default-pill">Default (Recommended)</span>
              </span>
              <span className="option-desc">Do not delete. Keep all student photos and files safe.</span>
            </div>
            {selectedOption === "no" && <FaCheckCircle className="option-check-icon no-check" />}
          </label>

          <label
            className={`delete-option-label ${selectedOption === "yes" ? "active-yes" : ""}`}
            onClick={() => setSelectedOption("yes")}
          >
            <input
              type="radio"
              name="deleteOption"
              value="yes"
              checked={selectedOption === "yes"}
              onChange={() => setSelectedOption("yes")}
            />
            <div className="option-text">
              <span className="option-headline text-danger">Yes, Delete Permanently</span>
              <span className="option-desc">
                Permanently delete this folder and its contents.
              </span>
            </div>
            {selectedOption === "yes" && <FaTrashAlt className="option-check-icon yes-check" />}
          </label>
        </div>

        {/* Modal Buttons */}
        <div className="delete-modal-actions">
          <button
            type="button"
            className="delete-btn-cancel"
            autoFocus
            onClick={onClose}
            disabled={loading}
          >
            No, Cancel
          </button>

          <button
            type="button"
            className={`delete-btn-confirm ${selectedOption !== "yes" ? "disabled-btn" : ""}`}
            disabled={selectedOption !== "yes" || loading}
            onClick={handleConfirm}
          >
            {loading ? "Deleting..." : "Yes, Delete Folder"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteFolderModal;

